import { Component, Inject } from "@angular/core";
import { AppBarTitleService, SsoAccountFacade, UserMessageBridgeService, UserMessageData, UserMessageSubjects } from "common";
import { ReferralCodeBaseComponent } from "./referral-code-base.component";
import { ActivatedRoute } from "@angular/router";
import { EntityFacade } from "../entity/domain/+state/entity.facade";

@Component({
    selector: "ifp-referral-code-message",
    templateUrl: "./referral-code.component.html",
    styleUrls: ["./referral-code.component.scss"],
    standalone: false
})
export class ReferralCodeMesssageComponent extends ReferralCodeBaseComponent<UserMessageData> {
  referReminderId: number;

  constructor(
    appBarTitleService: AppBarTitleService,
    @Inject(UserMessageBridgeService) userMessageBridgeService: UserMessageBridgeService,
    entityFacade: EntityFacade,
    route: ActivatedRoute,
    ssoAccountFacade: SsoAccountFacade
  ) {
    super(appBarTitleService, userMessageBridgeService, entityFacade, route, ssoAccountFacade);
    this._searchCondition = { subject: UserMessageSubjects.EarnUpTo10000 };
  }
}
